/* ================================================== */
/* LINKS → Back
/* ================================================== */

$(document).ready(function() {

	// Save scroll on movies list
	if ($('.movies-list').length || $('[data-back-link="enabled"]').length) {
		sessionStorage.setItem('backToList', window.location.href);
	} else if ($('.article--movies').length && $('.back a').length && sessionStorage.getItem('backToList') !== null) {
		$('.back a').attr('href', 'javascript:history.back()');
		sessionStorage.removeItem('backToList');
	} else {
		sessionStorage.removeItem('backToList');
	}

});